import axios from 'axios';
import { AdminUserSession, AxymaSession, AxymaSessionDetails, LoginDiscovery, LoginMethod } from '../types/auth';

export const authApi = axios.create({
  baseURL: process.env.REACT_APP_AUTH_API_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

export const authService = {
  discover: async (login: string) => {
    const response = await authApi.post<LoginDiscovery>('login/discovery', { login });

    return response.data;
  },

  login: async (email: string, senha: string) => {
    const response = await authApi.post<{
      accessToken: string;
      csrfToken: string;
      session: AxymaSession;
      userName: string;
      empresa: string;
    }>('login', { email, senha, channel: 'web' });

    return response.data;
  },

  startSso: async (
    provider: Exclude<LoginMethod, 'password'>,
    empresaId: string,
    returnTo: string,
  ) => {
    const response = await authApi.post<{ authorizationUrl: string }>(
      `sso/${provider}/start`,
      { empresaId, returnTo, channel: 'web' },
    );

    return response.data;
  },

  refresh: async (csrfToken: string) => {
    const response = await authApi.post<{ accessToken: string; session: AxymaSession }>(
      'session/refresh',
      {},
      { headers: { 'X-CSRF-Token': csrfToken } },
    );

    return response.data;
  },

  me: async (accessToken: string) => {
    const response = await authApi.get<{ session: AxymaSessionDetails }>('session/me', {
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.data;
  },

  firebaseToken: async (accessToken: string) => {
    const response = await authApi.post<{ customToken: string }>(
      'session/firebase-token',
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );

    return response.data;
  },

  logout: async (accessToken: string, all = false) => {
    return authApi.post(
      all ? 'session/logout-all' : 'session/logout',
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );
  },

  listUserSessions: async (accessToken: string, userId: string) => {
    const response = await authApi.get<{ sessions: AdminUserSession[] }>(
      `session/admin/users/${encodeURIComponent(userId)}/sessions`,
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );

    return response.data.sessions;
  },

  logoutUserSession: async (accessToken: string, userId: string, sessionId: string) => {
    const response = await authApi.post<{ message: string; session: Pick<AdminUserSession, 'id' | 'userId' | 'empresaId' | 'status' | 'revokedAt' | 'revokedReason'> }>(
      `session/admin/users/${encodeURIComponent(userId)}/sessions/${encodeURIComponent(sessionId)}/logout`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } },
    );

    return response.data;
  },
};
